import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AutocompleteModule } from '../../../components/autocomplete/autocomplete.module';
import { FileUsageModule } from '../../../components/file-usage/file-usage.module';
import { TranslateModule } from '../../../components/translate/translate.module';
import { InViewDirectiveModule } from '../../../directives/in-view/in-view.directive.module';
import { RequestService } from '../request.service';
import { RequestConsentDialogComponent } from './request-consent-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    TranslateModule,
    FileUsageModule,
    AutocompleteModule,
    InViewDirectiveModule,

    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,
  ],
  exports: [RequestConsentDialogComponent],
  declarations: [RequestConsentDialogComponent],
  providers: [RequestService],
})
export class RequestConsentDialogModule {}
